const IMG = {
  worship: "https://images.unsplash.com/photo-1470229722913-7c0e2dbbafd3?auto=format&fit=crop&w=1600&q=80",
  community: "https://images.unsplash.com/photo-1529156069898-49953e39b3ac?auto=format&fit=crop&w=1600&q=80",
  youth: "https://images.unsplash.com/photo-1523240795612-9a054b0db644?auto=format&fit=crop&w=1600&q=80",
  pastor: "https://images.unsplash.com/photo-1475721027785-f74eccf877e2?auto=format&fit=crop&w=1600&q=80",
  coffee: "https://images.unsplash.com/photo-1521017432531-fbd92d768814?auto=format&fit=crop&w=1600&q=80",
};

export const SERMONS = [
  { id: "ser-01", date: "2026-07-12", duration: "38 min", thumb: IMG.pastor, youtube_id: "",
    title: { es: "Fe que se Mueve", en: "Faith that Moves" },
    series: { es: "Fundamentos", en: "Foundations" },
    speaker: { es: "Pr. Daniel Rivera", en: "Ps. Daniel Rivera" },
    description: { es: "La fe no es un sentimiento: es una decisión que se camina todos los días.",
                   en: "Faith is not a feeling: it is a decision you walk out every day." } },
  { id: "ser-02", date: "2026-07-05", duration: "41 min", thumb: IMG.worship, youtube_id: "",
    title: { es: "Sin Miedo al Futuro", en: "Unafraid of the Future" },
    series: { es: "Sin Miedo", en: "Fearless" },
    speaker: { es: "Pr. Daniel Rivera", en: "Ps. Daniel Rivera" },
    description: { es: "Cómo confiar en Dios cuando el mañana parece incierto.",
                   en: "How to trust God when tomorrow feels uncertain." } },
  { id: "ser-03", date: "2026-06-28", duration: "35 min", thumb: IMG.community, youtube_id: "",
    title: { es: "Familia, no Multitud", en: "Family, not a Crowd" },
    series: { es: "Fundamentos", en: "Foundations" },
    speaker: { es: "Pra. Sarah Rivera", en: "Ps. Sarah Rivera" },
    description: { es: "La iglesia no es un evento al que asistes, es una familia a la que perteneces.",
                   en: "Church is not an event you attend, it is a family you belong to." } },
  { id: "ser-04", date: "2026-06-21", duration: "44 min", thumb: IMG.coffee, youtube_id: "",
    title: { es: "La Mesa Está Servida", en: "The Table is Set" },
    series: { es: "Gracia", en: "Grace" },
    speaker: { es: "Pr. Daniel Rivera", en: "Ps. Daniel Rivera" },
    description: { es: "Hay un lugar para ti en la mesa de Dios, tal como eres.",
                   en: "There is a seat for you at God's table, just as you are." } },
  { id: "ser-05", date: "2026-06-14", duration: "39 min", thumb: IMG.youth, youtube_id: "",
    title: { es: "Generación con Propósito", en: "A Generation with Purpose" },
    series: { es: "Sin Miedo", en: "Fearless" },
    speaker: { es: "Equipo MVMT Jóvenes", en: "MVMT Youth Team" },
    description: { es: "Dios no espera a que seas mayor para usarte.",
                   en: "God does not wait for you to be older to use you." } },
  { id: "ser-06", date: "2026-06-07", duration: "36 min", thumb: IMG.worship, youtube_id: "",
    title: { es: "Adoración que Transforma", en: "Worship that Transforms" },
    series: { es: "Gracia", en: "Grace" },
    speaker: { es: "Pra. Sarah Rivera", en: "Ps. Sarah Rivera" },
    description: { es: "La adoración no es la antesala del mensaje: es el encuentro mismo.",
                   en: "Worship is not the warm-up to the message: it is the encounter itself." } },
];
